var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.1861C14.2726 26.8876 13.9561 26.463 13.5794 25.933C12.7895 24.8217 11.7365 23.2499 10.6841 21.4082C8.56823 17.7054 6.5 12.9884 6.5 8.75C6.5 6.55736 7.34627 4.45734 8.84823 2.91121C10.3497 1.36557 12.383 0.5 14.5 0.5C16.617 0.5 18.6503 1.36557 20.1518 2.91121C21.6537 4.45734 22.5 6.55736 22.5 8.75C22.5 12.9884 20.4318 17.7054 18.3159 21.4082C17.2635 23.2499 16.2105 24.8217 15.4206 25.933C15.0439 26.463 14.7274 26.8876 14.5 27.1861ZM10.5351 12.8107C11.5841 13.8906 13.01 14.5 14.5 14.5C15.99 14.5 17.4159 13.8906 18.4649 12.8107C19.5134 11.7313 20.1 10.2704 20.1 8.75C20.1 7.22961 19.5134 5.76867 18.4649 4.6893C17.4159 3.60943 15.99 3 14.5 3C13.01 3 11.5841 3.60943 10.5351 4.6893C9.48658 5.76867 8.9 7.22961 8.9 8.75C8.9 10.2704 9.48658 11.7313 10.5351 12.8107Z",
    fill: "#FF6363",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4e1b5dabf7672a08656c30873e0685b9.svg";
export { ForwardRef as ReactComponent };